import React from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <>
      <LandingPage />
      <Toaster position="top-right" />
    </>
  );
}

export default App;